export const MIN_GROUP_SIZE = 2;

export const MAX_GROUP_SIZE = 1000;

export const DEFAULT_DURATION = 14;

export const DEFAULT_GROUP_SIZE = 20;

export const DEFAULT_CLIENT_CONFERENCES_COUNT = 0;
